<template>
    <el-drawer
        title="添加观演人"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        :show-close="false"
        append-to-body
    >
        <div class="drawer-content">
            <el-form
                
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
            >
                
                <el-form-item prop="documentType" label="证件类型">
                    <el-select v-model="formDatas.documentType" size="medium" placeholder="请选择证件类型" @change="formDatas.documentNumber = ''">
                        <el-option v-for="(item,index) in documentTypeList" :key="index" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="documentNumber" label="证件号码:" >
                    <el-input v-model="formDatas.documentNumber" placeholder="请输入证件号码" size="medium" :maxlength="formDatas.documentType == 1 ? 18 : 20" ></el-input>
                </el-form-item>
				<el-form-item prop="documentName" label="证件姓名:" >
				    <el-input v-model="formDatas.documentName" placeholder="请输入观演人" size="medium" maxlength="40" show-word-limit ></el-input>
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    documentName:'',
    documentType:1,
    documentNumber:'',
	goodsId:'',
	ticketId:''
}
export default {
    data(){
        const checkLength = (rule, value, callback) => {            
            const arr = [null, '身份证号填写错误', '港澳通行证', '台胞证', '护照'];
            let len = 18, msg = `${arr[this.formDatas.documentType]}`;
            if(this.formDatas.documentType != 1){
                len = 20;
                msg += `最多允许填写20个字符` 
            }
            if (value.length > len || this.formDatas.documentType == 1 && value.length != len) {
                callback(new Error(msg));
            } else {
                callback();
            }
        }
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas: {
                ...defaultFormData,
            },
            rules:{
                documentName:[{required: true, message: '请选填写观演人'}],
                documentType:[{required: true, message: '请选择证件类型'}],
                documentNumber:[{required: true, message: '请输入证件号码'}, { validator: checkLength, trigger: 'blur' }],
            },
            itemData:null,
            
        }
    },
    computed:{
        documentTypeList(){
            return [{
                label:'身份证',
                value:1
            },{
                label:'港澳居民来往内地通行证',
                value:2
            },{
                label:'台湾居民来往大陆通行证',
                value:3
            },{
                label:'护照',
                value:4
            },{
                label:'外国人永久居留身份证',
                value:5
            },{
                label:'港澳台居民居住证',
                value:6
            }]
        }
    },
    methods:{
        close(){
            this.formDatas = { ...defaultFormData };
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
        },
        show(data){
			console.log(data)
            this.itemData = {...data};
            this.formDatas.goodsId = data.activityId;
			this.formDatas.ticketId = data.id
            this.drawerShow = true;
        },
        
        submitForm(){
            this.$refs['formDatas'].validate((valid) => {
                if(valid){
                    this.btnLoading = true;
                    this.$request({
                        url: '/activityTicketWhite/addCommonPerformer',
                        method: "POST",
                        data:{
                            ...this.formDatas
                        }
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$message.success('操作成功');                            
                            this.$emit("onUpdate");
            				this.close()
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.btnLoading = false;
                    })
                }
            })        
        }
    }
}
</script>